export const siteConfig = {
  name: 'Nectar Travel',
  description: '专业的旅游定制服务',
  contact: {
    email: 'info@nectartravel.com',
    phone: '+1 234 567 890'
  },
  social: {
    facebook: '#',
    instagram: '#'
  }
};

export default siteConfig;